import { CreateContactParams } from './types'
import client from '../../client'

export * from './types'

export const create = async (params: CreateContactParams) => {
  return await client.put(`/user/contacts/send`, params)
}
